module.exports = __webpack_public_path__ + "assets/ed9b7e1ba8f95313809fe56e667f2b7c.ttf";